import React, { ReactElement, useEffect, useState } from "react"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { getTalkToCarrotNeedHelpGuidance } from "../../lib/contentful/contentfulClient"
import { useHistory } from "react-router"
import { GuidanceElement } from "../../lib/contentful/components/GuidanceElement"
import { SendMessage, zendeskSubjects } from "./TalkToCarrotSendMessage"
import Guidance from "../views/atoms/Guidance"
import { TalkToCarrotLegal } from "./TalkToCarrotLegal"


const HelpPage = ({ breadcrumbs, baseUrl }) => {
  const history = useHistory()
  const [guidance, setGuidance] = useState<ReactElement<typeof Guidance>>(null)
  const helpPath = `${baseUrl}/i-need-help`

  useEffect(() => {
    const loadGuidance = async () => {
      const guidance = await getTalkToCarrotNeedHelpGuidance()
      setGuidance(<GuidanceElement guidance={guidance} />)
    }
    if (!guidance) {
      loadGuidance()
    }
  }, [])

  return (
    <MasterLayout
      footer={<TalkToCarrotLegal />}
      header={
        <BreadcrumbsHeader
          breadcrumbs={[
            ...breadcrumbs,
            <Breadcrumb title={"I need help"} isActive onClick={() => history.push(helpPath)} />
          ]}
        />
      }
    >
      <TwoColumnRightPrimary
        secondaryContent={guidance}
        primaryContent={<SendMessage subject={zendeskSubjects.I_NEED_HELP} />}
      />
    </MasterLayout>
  )
}

export { HelpPage }
